<template>
  <div id="login_page">
    <div id="content">
      <div class="left">
        <div class="status_bg xb-bg" v-if="statusShow && isStatus != 4">
          <!-- 【登录】 -->
          <template v-if="login_text">
            <span class="login_click" @click="handleLogin">查询申请状态</span>
          </template>
          <template v-else>
            【
            <span
              style="cursor: pointer; text-decoration: underline;"
              @click="edit"
            >
              退出
            </span>
            】 当前状态：{{ get_text }}
          </template>
        </div>
        <template v-else>
          <div class="statu_wrap">
            <div class="status_bg_min xb-bg">
              【
              <span
                style="cursor: pointer; text-decoration: underline;"
                @click="edit"
              >
                退出
              </span>
              】当前状态：已获得
            </div>
            <div class="sen_info xb-bg" @click="handlePass"></div>
          </div>
        </template>

        <div class="btn_wrap">
          <template v-if="isTimer">
            <template v-if="isStatus == 1">
              <div class="userUin xb-bg" @click="handleUIn"></div>
            </template>
            <template v-else-if="isStatus == 2 || isStatus == 3">
              <div class="getUin xb-bg"></div>
            </template>
            <template v-else-if="isStatus == 4">
              <div class="yesUin xb-bg"></div>
            </template>
            <template v-else-if="isStatus == 5">
              <div class="NorelieveUin xb-bg" @click="handleRelieve"></div>
            </template>
            <template v-else-if="isStatus == 6 || isStatus == 8">
              <div class="YesrelieveUin xb-bg"></div>
            </template>
            <template v-else>
              <div class="userUin xb-bg" @click="handleUIn"></div>
            </template>
          </template>
          <template v-else>
            <div class="timerEnd xb-bg"></div>
          </template>
          <!-- <a href="http://mdownload.mini1.cn/office/MiniworldBeta_PC.exe">
            <div class="down xb-bg"></div>
          </a> -->
          <a href="https://app.mini1.cn/export/betaPC">
            <div class="down xb-bg"></div>
          </a>
        </div>

        <div class="footer">
          <div class="title">相关说明</div>
          <ul class="content">
            <li>
              1、先遣服资格现只针对官版安卓和官版PC玩家开放，请使用官版迷你号和密码登录
            </li>
            <li>
              2、申请成功后，请耐心等待系统审核。申请结果可于次月1-10日在申请界面查看
            </li>
            <li>3、每个迷你号只允许同时使用一个先遣服账号</li>
            <li>
              4、先遣服账号超过三个月未登录将被封停。封停后可在当前页面申请解封
            </li>
            <li>
              5、先遣服账号有限，官方将视实际情况调整每月发放数量。若部分时期先遣服人数达到最大值，则对应月份将不予发放先遣服账号
            </li>
            <li>注：申请时间为每月11日至当月最后一日。</li>
          </ul>
        </div>
      </div>
      <div class="right"></div>
    </div>

    <box :boxShow="boxShowTips" @close="closeVal">
      <div class="wrap_data" :class="{ on: fontSize }">{{ tip_text }}</div>
    </box>

  </div>
</template>
<script>
import { queryURLParam, getAvatarUrl } from '../common/utils'
export default {
  name: 'loginPage',
  data() {
    return {
      statusShow: true,
      boxShowTips: false, //提示框
      boxShowLogin: false, //登录框
      login_text: false, //判断是否在登录状态
      userPerwer: true, //官方非官方

      tipOne: false, //申请提交
      tipsTwo: false, //发送账密

      fontSize: true, //控制字体大小
      isTimer: true,

      isAuthData: null, //登录态的数据
      isAuthUserData: null,
      ishandleUIn: false, //点击申请账号变量判断
      isStatus: 0, //获取到状态值

      applyData: null, //apply申请账号数据
      sso: null
    }
  },
  mounted() {
    //在没有url和检测没有session的情况下
    this.loginInit()
  },
  computed: {
    ssoStr() {
      return process.env.NODE_ENV === 'production'
        ? process.env.VUE_APP_REALEASE === 'test'
          ? 'http://sso.mini.me'
          : 'https://sso.mini1.cn'
        : 'http://sso.mini.me'
    },
    //计算申请状态展示
    get_text() {
      let data = ''
      switch (this.isStatus) {
        case 1:
          data = '可申请'
          break
        case 2:
          data = '审核中'
          break
        case 3:
          data = '未获得' //申请被拒绝
          break
        case 4:
          data = '已获得'
          break
        case 5:
          data = '已封停'
          break
        case 6:
          data = '审核中'
          break
        case 8:
          data = '未通过' //申请解封被拒绝
          break
        case 10:
          data = '非官版'
          break
        default:
          data = '无状态'
      }
      return data
    },
    //计算提示框文案展示
    tip_text() {
      let data = ''
      if (!this.userPerwer) {
        data = '非官版用户'
      } else if (this.tipOne) {
        data =
          '您的申请已提交，请耐心等待系统审核。申请结果可于次月1-10日在申请页面查看'
      } else if (this.tipsTwo) {
        data = '先遣服账密已发送至游戏内邮箱，请注意查收'
      }
      return data
    }
  },
  methods: {
    //login初始化
    loginInit() {
      this.sso = new window.MiNiWan.MiniWanSso({
        url: this.ssoStr,
        callback: (state, info) => {
          if (state == 1) {
            console.log('新的登录')
            this.isAuthUserData = info
            this.ishandleUIn = true
            this.login_text = false //显示已登录
            this.handleLoginAsy()
          } else if (state == 2) {
            console.log('已经登入')
            this.ishandleUIn = true
            this.login_text = false //显示已登录
            this.isAuthUserData = info
            this.handleLoginAsy()
          } else if (state == 0) {
            console.log('没有登入')
            this.login_text = true
            this.loginStatus = false
          } else if (state == 4) {
            this.login_text = true
            this.loginStatus = false
            console.log('sso内的接口调用失败')
          }
          console.log(info)
        },
      })
    },

    //退出
    edit() {
      this.sso.clear()
      this.ishandleUIn = false
      this.login_text = true //未登陆状态
      this.isStatus = 0 //获取到状态值
    },

    //一键发送账密
    async handlePass() {
      try {
        this.applyData = {
          uin: this.isAuthUserData.uin,
        }
        const { data } = await this.$http.api.home.sendemail(this.applyData)
        if (data.code == 200) {
          this.boxShowTips = true
          this.tipone = false
          this.tipsTwo = true
          this.userPerwer = true
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    //账号登录接口
    async handleLoginAsy() {
      try {
        let user = {
          uin: this.isAuthUserData.uin,
        }
        const { data } = await this.$http.api.home.loginUser(user)
        if (data.code == 200) {
          //登录成功
          this.isStatus = data.data.status //对应的状态值
          if (data.data.date_status) {
            this.isTimer = true //在对应的时间内
          } else {
            this.isTimer = false //未在对应的时间内
            this.$message({
              type: 'error',
              message: '不在申请时间范围内，无法申请!',
            })
          }
          this.ishandleUIn = true
          this.login_text = false //显示已登录
        } else if (data.code == 412) {
          //登录之后的非官版用户
          this.boxShowTips = true

          //三个文案状态控制
          this.userPerwer = false
          this.tipOne = false
          this.tipsTwo = false
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    //账号申请接口(传1)申请解封（传2）
    async applyTo(val) {
      try {
          // console.log('走密码接口')
          this.applyData = {
            uin:this.isAuthUserData.uin,
            status: val,
        }
        const { data } = await this.$http.api.home.uinApply(this.applyData)
        if (data.code == 200) {
          this.boxShowTips = true
          this.userPerwer = true
          this.tipsTwo = false
          this.tipOne = true
          if (val == 1) {
            this.isStatus = 2
          } else {
            this.isStatus = 6
          }
          let auth = {
            uin:this.isAuthUserData.uin,
            status: this.isStatus,
          }
        } else if (data.code == 412) {
          this.boxShowTips = true
          this.userPerwer = false
          this.tipOne = false
          this.tipsTwo = false
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    //点击登录
    handleLogin() {
      window.location.href = `${this.ssoStr}?url=${window.location.href}`
    },
    //点击申请账号
    handleUIn() {
      // return
      if (this.isAuthUser || this.ishandleUIn) {
        //有登录的时候
        this.applyTo(1)
      } else {
        window.location.href = `${this.ssoStr}?url=${window.location.href}`
      }
    },
    //点击申请解封
    handleRelieve() {
      this.applyTo(2)
    },
    closeVal(val) {
      this.boxShowTips = false
    }
  },
}
</script>
<style lang="scss" scoped>
#login_page {
  background: url('../assets/images/login_page.jpg') no-repeat top center/1920px
    1080px;
  width: 100%;
  padding: 325px 0 35px;
  #content {
    background: url('../assets/images/content.png') no-repeat top center;
    width: 1298px;
    height: 700px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 18px 42px 0 0;
    .left {
      width: 470px;
      height: 668px;
      margin-right: 9px;
      .status_bg {
        width: 406px;
        height: 97px;
        background-position: -10px -10px;
        margin: 27px auto 0px;
        font-size: 25px;
        font-weight: 600;
        line-height: 97px;
        letter-spacing: 0px;
        color: #ffffff;
        text-align: center;
        padding-right: 12px;
        .login_click {
          cursor: pointer;
        }
      }
      .statu_wrap {
        margin: 28px 0 20px 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        .status_bg_min {
          width: 288px;
          height: 74px;
          background-position: -10px -129px;
          font-size: 19px;
          font-weight: 600;
          line-height: 70px;
          letter-spacing: 0px;
          color: #ffffff;
          text-align: center;
          padding-right: 12px;
        }
        .sen_info {
          width: 113px;
          height: 36px;
          background-position: -436px -134px;
          cursor: pointer;
        }
      }
      .btn_wrap {
        width: 340px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .userUin {
          width: 152px;
          height: 46px;
          background-position: -436px -10px;
          cursor: pointer;
        }
        .yesUin {
          width: 152px;
          height: 46px;
          background: url('../assets/images/yesUin.png') no-repeat top
            center/152px 46px;
          // background-position: -10px -363px;
        }
        .getUin {
          width: 152px;
          height: 46px;
          background: url('../assets/images/getUin.png') no-repeat top
            center/152px 46px;
          // background-position: -182px -363px;
        }
        .NorelieveUin {
          background: url('../assets/images/NorelieveUin.png') no-repeat top
            center/152px 46px;
          width: 152px;
          height: 46px;
          cursor: pointer;
        }
        .YesrelieveUin {
          background: url('../assets/images/YesrelieveUin.png') no-repeat top
            center/152px 46px;
          width: 152px;
          height: 46px;
        }
        .timerEnd {
          background-position: -9px -363px;
          width: 152px;
          height: 46px;
        }
        .down {
          width: 152px;
          height: 47px;
          background-position: -210px -223px;
          cursor: pointer;
        }
      }
      .footer {
        background: url('../assets/images/footer.png') no-repeat top
          center/484px 496px;
        height: 496px;
        width: 474px;
        margin: 0 auto;
        padding-top: 50px;
        .title {
          font-family: MicrosoftYaHei-Bold;
          color: #652414;
          font-size: 26px;
          letter-spacing: 0px;
          font-weight: 600;
          font-stretch: normal;
          text-align: center;
          width: 320px;
          margin: 0 auto;
        }
        .content {
          margin: 28px auto 0;
          width: 320px;
          height: 280px;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: 0px;
          color: #652414;
          font-weight: 600;
        }
      }
    }
    .right {
      background: url('../assets/images/right.png') no-repeat top center/729px
        668px;
      width: 707px;
      height: 668px;
    }
  }

  //box
  .wrap_data {
    width: 500px;
    height: 200px;
    margin: 40px auto 0;
    color: #622819;
    font-size: 32px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    &.on {
      font-size: 24px;
    }
  }
  .wrap_login_data {
    width: 500px;
    height: 230px;
    margin: 20px auto 0;
    .title {
      color: #ffffff;
      font-size: 29px;
      letter-spacing: 0px;
      font-weight: 600;
      text-align: center;
    }
    .form_wrap {
      margin: 10px auto 0;
      width: 445px;
      padding-left: 20px;
      position: relative;
      .btn_login {
        width: 180px;
        height: 54px;
        background-position: -10px -223px;
        margin-left: 35%;
        transform: scale(0.8);
        cursor: pointer;
      }
      .text_wrap {
        position: absolute;
        right: 81px;
        bottom: 78px;
        width: 100px;
        height: 36px;
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="scss">
.el-form-item__label {
  color: #622819 !important;
  font-size: 19px !important;
  font-weight: 600;
}
.el-form-item {
  margin-bottom: 17px !important;
}
</style>
